import { NgClass, SlicePipe } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { IconComponent } from '@claas/claas-ui-components';
import { AlertBannerComponent } from '@claas/claas-ui-components/notification/alert-banner';
import { IndividualConfig, Toast } from 'ngx-toastr';
import { AlertService } from '@cde-fe-app/app/cde-toast/services/alert.service';
import { animationsConfig } from '@cde-fe-app/app/cde-toast/utils/animations';
import { CdeToastOptions } from '@cde-fe-app/app/cde-toast/utils/toastr-options';
import { CdeToastCountdownComponent } from './cde-toast-countdown/cde-toast-countdown.component';
import { AlertIconComponent } from '../cde-toast-icon/alert/alert-icon.component';
import { SnackbarIconComponent } from '../cde-toast-icon/snackbar/snackbar-icon/snackbar-icon.component';

@Component({
  selector: 'app-cde-toast',
  templateUrl: './cde-toast.component.html',
  styleUrls: ['./cde-toast.component.scss'],
  animations: [animationsConfig.animeTrigger],
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AlertBannerComponent,
    AlertIconComponent,
    CdeToastCountdownComponent,
    IconComponent,
    NgClass,
    SlicePipe,
    SnackbarIconComponent,
  ],
})
export class CdeToastComponent extends Toast {
  readonly alertService = inject(AlertService);
  private readonly toastConfig = this.toastPackage.config as IndividualConfig & CdeToastOptions;
  toastId = this.toastPackage.toastId;
  showAction = this.toastConfig.showToastAction ?? false;
  showCounter = this.toastConfig.showCounter ?? false;
  actionName = this.toastConfig.actionName ?? 'Action';
  toastType = this.toastConfig.type ?? this.toastPackage.toastType;
  stringLimit = this.toastConfig.stringLimit ?? 88;
  actionFunction = this.toastConfig.action ?? (() => undefined);

  action(): void {
    this.actionFunction.apply(undefined);
  }

  removeToast(id: number): void {
    this.toastrService.remove(id);
  }
}
